import type { ReactNode } from 'react';
import { Modal } from './Modal';
import { ModalFooter } from './ModalFooter';

/**
 * Styled confirmation dialog — the React replacement for Angular's ConfirmModalCtrl /
 * dialog_confirm.html (and the ad-hoc window.confirm() calls). The parent controls
 * visibility by conditionally rendering it.
 */
interface Props {
  title: string;
  confirmLabel?: string;
  saving?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  children: ReactNode;
  testId?: string;
}

export function ConfirmModal({ title, confirmLabel = 'OK', saving, onConfirm, onClose, children, testId }: Props) {
  return (
    <Modal
      title={title}
      icon="fas fa-question-circle"
      onClose={onClose}
      testId={testId}
      footer={<ModalFooter onClose={onClose} onNext={onConfirm} nextLabel={confirmLabel} saving={saving} submitTestId="modal-confirm-btn" />}
    >
      {children}
    </Modal>
  );
}
